import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Translation, FormData } from "./types";

interface UseContextTextParams {
  formData?: FormData;
  translations: Translation[];
  localeIndex: number;
}

/**
 * Hook to build context text from form data based on the selected locale
 */
export const useContextText = ({ formData, translations, localeIndex }: UseContextTextParams): string => {
  const [contextText, setContextText] = useState<string>("");
  const { t } = useTranslation();

  useEffect(() => {
    const translation = translations[localeIndex];
    const equipment = formData?.levels?.[0]?.equipment ? formData?.levels?.[0]?.equipment.join(", ") : "";
    const position = formData?.levels?.[0]?.position || "";
    const movement = formData?.levels?.[0]?.movement || "";

    const { title, variation_title, about } = translation || {};

    setContextText(
      `${t("imageGenerator.contextPrefix.title")} ${title}${variation_title ? ` - ${variation_title}` : ""}
${t("imageGenerator.contextPrefix.about")} ${about}
${equipment ? t("imageGenerator.contextPrefix.equipment") + " " + equipment : ""}
${position ? t("imageGenerator.contextPrefix.position") + " " + position : ""}
${movement ? t("imageGenerator.contextPrefix.movement") + " " + movement : ""}
`
    );
  }, [formData, localeIndex, translations, t]);

  return contextText;
};
